import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Ornament } from './Ornament';
import { checkoutUrl, collection, images, offerCta } from '../data/content';
export function Collection() {
  return <section id="todo-incluido" className="scroll-mt-4 bg-brown text-cream" data-id="element-41" data-mp="2w9odgwr672b7">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-6 lg:py-24" data-id="element-42" data-mp="2rb4r4v8nzoib">
        <div className="mx-auto max-w-2xl text-center" data-id="element-43" data-mp="3oydk1bazvzuc">
          <Ornament light data-id="element-44" data-mp="3ox2eb5xzoi0l" />
          <h2 className="mt-5 font-display text-[2.3rem] font-semibold uppercase leading-none tracking-[0.06em] sm:text-5xl" data-id="element-45" data-mp="3jyr42u3s85hu">
            Todo esto es tuyo hoy
          </h2>
          <p className="mt-4 font-sans text-[0.98rem] leading-relaxed text-cream/80 sm:text-[1.05rem]" data-id="element-46" data-mp="3f1qz6mio58sb">
            El desafío de 31 días y 5 bonos de regalo: una colección completa, creada para
            acompañarte en cada paso del camino.
          </p>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl items-center gap-12 lg:grid-cols-[1.1fr_1fr] lg:gap-14" data-id="element-47" data-mp="1ykmti9qpmfca">
          <div className="mx-auto w-full max-w-xl lg:max-w-none" data-id="element-48" data-mp="uhi33uqdc4mf">
            <img src={images.bundle} alt={images.bundleAlt} loading="lazy" className="h-auto w-full drop-shadow-[0_24px_30px_rgba(0,0,0,0.35)]" data-id="element-49" data-mp="zgbftkxtzrlj" />
          </div>

          <div data-id="element-50" data-mp="phvmdbbc068v">
            <ul className="divide-y divide-cream/15 border-y border-cream/15" data-id="element-51" data-mp="phlxxs5xq75a">
              {collection.map(item => <li key={item.title} className="flex items-center gap-3.5 py-3.5" data-id="element-52" data-mp="bpxl1mnv3en9">
                  <span className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-gold-soft" data-id="element-53" data-mp="gh7aon9euhz5">
                    <CheckIcon className="h-3.5 w-3.5 text-brown" strokeWidth={3} aria-hidden="true" data-id="element-54" data-mp="1st5w6sfojfy" />
                  </span>
                  <span className="min-w-0 flex-1 font-sans text-[0.95rem] font-medium leading-snug text-cream" data-id="element-55" data-mp="6s5scqfe7oi0">
                    {item.title}
                  </span>
                  <span className={`flex-none whitespace-nowrap rounded-full px-2.5 py-0.5 font-sans text-[0.6rem] font-bold uppercase tracking-[0.12em] ${item.kind === 'principal' ? 'bg-cream text-brown' : 'bg-rose-soft text-brown'}`} data-id="element-56" data-mp="3sz40bk2xulyb">
                    {item.kind === 'principal' ? 'Principal' : 'Gratis'}
                  </span>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-57" data-mp="1pnpkrycuc4yb">
              <CtaButton href={checkoutUrl} data-id="element-58" data-mp="1krqto304o8u7">{offerCta}</CtaButton>
            </div>
          </div>
        </div>
      </div>
    </section>;
}